import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Heading, Image, List, Select, Text, TextInput } from "grommet";
import { debounce } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import { AliasViewModel, searchAliases } from "../aliases/AliasStore";
import { NavigationButton } from "../components/NavigationButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import GameDetails from "./GameDetails";
import { getGame, GameViewModel, updateGame, UpdateGameRequest } from "./GamesStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;
const idBadge = <FontAwesomeIcon icon={["fad", "id-badge"]}></FontAwesomeIcon>;

const GameProfile = () => {
    let { id } = useParams<{ id: string }>();

    let { pathname } = useLocation();
    let navigate = useNavigate();

    React.useEffect(() => {
        if (!pathname.endsWith("/")) {
            navigate("details", { replace: true });
        }
    }, [pathname]);

    React.useEffect(() => {
        fetchGame();
    }, []);

    const [game, setGame] = React.useState({} as GameViewModel | UpdateGameRequest);
    const [isLoading, setIsLoading] = React.useState(true);

    let [error, setError] = React.useState("");

    const fetchGame = () => {
        return getGame(id).then((result) => {
            if (result.status == 200) {
                setGame(result.data.result);
            } else {
                setGame({} as GameViewModel);
            }
            setIsLoading(false);
        });
    };

    const [isUpdating, setIsUpdating] = React.useState(false);

    const onChange = (updatedGame) => {
        setGame({ ...game, ...updatedGame });
    };

    let update = () => {
        setIsUpdating(true);
        updateGame(game).then(
            (result) => {
                fetchGame().then((game) => {
                    setIsUpdating(false);
                });
            },
            (error) => {
                setError(error);
                setIsUpdating(false);
            }
        );
    };

    const hasWritePermission = usePermission("sport:games.write");

    return (
        <div>
            <SkeletonWrapper loading={isLoading}>
                <Heading size="small">
                    <Box direction="row" align="center" gap="small">
                        <Image src={game.logoUri + "?ts=" + Math.random()} alt="" style={{ height: "auto", maxWidth: "80px", width: "auto", maxHeight: "80px", objectFit: "contain" }} />
                        {game.name}
                    </Box>
                </Heading>

                <Box direction="row" align="center" justify="center" gap="medium">
                    <NavigationButton href={`details`} text={"Details"}></NavigationButton>
                    {error && <NavigationButton href={`error`} text={"Errors"}></NavigationButton>}
                </Box>

                <Routes>
                    <Route
                        path="details"
                        element={
                            <>
                                <GameDetails game={game} isBusy={!hasWritePermission || isUpdating} onChange={onChange}></GameDetails>
                                <br />
                                {hasWritePermission && (
                                    <>
                                        {/* @ts-ignore */}
                                        <Button primary onClick={update} disabled={isUpdating || !game.name} label="Update"></Button>
                                    </>
                                )}
                            </>
                        }
                    />
                    <Route
                        path="home"
                        element={
                            <>
                                <Button href={"/ue/games/" + game.id} icon={idBadge} label="View Home Page"></Button>
                            </>
                        }
                    />
                    <Route
                        path="error"
                        element={
                            <>
                                <pre>{JSON.stringify(error, null, 2)}</pre>
                            </>
                        }
                    />
                </Routes>
            </SkeletonWrapper>
        </div>
    );
};

export default GameProfile;
